import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoaderService {
  public isLoading = new BehaviorSubject(false);
  cantidadInProgress = 0;
  constructor() {}

  showLoader(): void {
    //Acumula la cantidad de peticiones en curso
    this.cantidadInProgress++;
    this.isLoading.next(true);
  }

  hideLoader(): void {
    //Elimina la cantidad de peticiones en curso
    this.cantidadInProgress--;
    //Si la cantidad de peticiones en curso es 0, oculta el loader
    if(this.cantidadInProgress == 0){
      this.isLoading.next(false);
    }
  }
}
